(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      // klaviyo back in stock button
      this.backInStockButton = this.form.querySelector('[data-trigger="backinstock"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          klaviyoItemAddedEvent();// klaviyo item added
          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.toggle('hidden', !errorMessage);
      errorWrapper.textContent = errorMessage || '';
    }

    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (disable) {
          submitButton?.setAttribute('disabled', 'disabled');
          if (text && submitButton) submitButton.textContent = text;
          // klaviyo back in stock button show
          submitButton.classList.add('kbis-active');
          this.backInStockButton?.setAttribute('data-visibility','true');
        } else if (submitButton) {
          submitButton.removeAttribute('disabled');
          const hasPreorder = submitButton.closest('.product').querySelector('[name="properties[preorder]"]');
          if (hasPreorder !== null) {
            submitButton.textContent = window.variantStrings.preOrder;
          } else {
            submitButton.textContent = this.hasAttribute(
              'data-has-selling-plan'
            )
              ? window.variantStrings.addSubscriptionToCart
              : window.variantStrings.addToCart;
          }
          // klaviyo back in stock button hide
          submitButton.classList.remove('kbis-active');
          this.backInStockButton?.setAttribute('data-visibility','false');
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();
